import { render, staticRenderFns } from "./ara.vue?vue&type=template&id=60e9ba78&scoped=true&"
import script from "./ara.vue?vue&type=script&lang=js&"
export * from "./ara.vue?vue&type=script&lang=js&"
import style0 from "./ara.vue?vue&type=style&index=0&id=60e9ba78&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e9ba78",
  null
  
)

export default component.exports